import React from 'react';

import styles from './ErrorPage.module.css';

import errorPageImg from 'assets/img/error_page.png';

const ErrorPage = () => (
  <div className={styles.container}>
    <div className={styles.contentWrapper}>
      <div className={styles.imgWrapper}>
        <img src={errorPageImg} alt="No data icon" />
      </div>
      <h2 className={styles.title}>Oops, something went wrong!</h2>
      <div className={styles.subTitle}>Please try again later</div>
    </div>
  </div>
);

export default ErrorPage;
